import qs from 'query-string';
import { get, post, put, del } from './baseApi';

export const OwnerApi = {
    fetch: (query, options) => get(`/owners?${qs.stringify(query)}`, options),
    fetchById: (id) => get(`/owners/${id}`),
    create: (data) => post('/owners', data),
    update: (id, data) => put(`/owners/${id}`, data),
    delete: (id) => del(`/owners/${id}`),
};
